<template>
  <div id="app">
    <template v-if="!hideList.includes($route.path)">
      <Hezuo v-if="show"></Hezuo>
      <HezuoPC v-else></HezuoPC>
    </template>
    <keep-alive exclude="vedioDetil,mvediodteil,pc_move,pc_record,min_move,min_record,m_column_details,my_focus,my_collection,my_comments,m_my,m_index">
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
import Hezuo from './components/tool/m_hezuo.vue'
import HezuoPC from './components/tool/hezuo.vue'
export default {
  name: 'App',
  components: {
    Hezuo,
    HezuoPC
  },
  data() {
    return {
      show: false,
      hideList:['/contentFile','/content_details','/m_content_file','/m_content_details']
    }
  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
  },
  created() {
    this.show = this._isMobile()

    //  this.GET_Token(); 
    // alert(JSON.stringify(this.USER()))


    //百度统计
    //  var _hmt = _hmt || [];
    //   (function() {
    //     var hm = document.createElement("script");
    //     hm.src = "https://hm.baidu.com/hm.js?8379155748b2097b694a2dcc7678ee2e";
    //     var s = document.getElementsByTagName("script")[0];
    //     s.parentNode.insertBefore(hm, s);
    //   })();
    let that = this;
    //图片放大
    $.fn.ImgZoomIn = function () {
      let src = $(this).attr('src');
      $('body,html').click(function () {

      })
      if (src.indexOf('?') >= 0) {
        src = src.slice(0, src.indexOf('?'))
      }
      if (that._isMobile()) {
        // alert("手机端");
        src = src + '?x-oss-process=image/resize,m_lfit,w_409'
      } else {
        // alert("pc端");
        src = src + '?x-oss-process=image/resize,m_lfit,w_689'
      }


      let bgstr, imgstr;
      $('#ImgZoomInImage').attr('src', '../images/1.png');
      bgstr = '<div id="ImgZoomInBG" onclick=$(\'#ImgZoomInBG\').hide();$(\'#ImgZoomInImage\').hide(); style=" background:#000000; filter:Alpha(Opacity=70); opacity:0.7; position:fixed; left:0; top:0; z-index:10000; width:100vw; height:100vh; display:none;"></div>';
      imgstr = '<img id="ImgZoomInImage" onclick=$(\'#ImgZoomInBG\').hide();$(\'#ImgZoomInImage\').hide(); src="' + src + '" alt="加载中！" style="cursor:pointer; display:none;left:50%;top:50%; transform: translate(-50%,-50%); position:fixed; z-index:10001;" />';
      if ($('#ImgZoomInBG').length < 1) {
        $('body').append(bgstr);
      }
      if ($('#ImgZoomInImage').length < 1) {
        $('body').append(imgstr);
      }
      else {
        $('#ImgZoomInImage').attr('src', src);
      }
      $('#ImgZoomInImage').css({ 'left': '50vw', 'top': '50vh', 'transform': 'translate(-50%,-50%)', 'position': 'fixed', 'z-index': '10001' });

      $('#ImgZoomInBG').show();
      $('#ImgZoomInImage').show();
      $("#ImgZoomInBG").click(function () {
        $('#ImgZoomInBG').hide();
        $('#ImgZoomInImage').hide();
      });
      $("#ImgZoomInImage").click(function () {
        $('#ImgZoomInImage').src('');
        $('#ImgZoomInBG').hide();
        $('#ImgZoomInImage').hide();
      });
    }
  },
}
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
  min-height: 100vh;
}
.spinner-box {
  width: 100%;
  height: 90vh;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  flex-direction: column;
}
.spinner-box div {
  margin-top: 10px;
  font-size: 20px;
}
.claloadding div:nth-child(2) {
  margin-top: 10px;
  font-size: 20px;
  color: #000;
}
.not-auth{
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue